import { isNumber } from '@/utils/is';
export default {
  name: 'InformationWindow',
  props: {
    siteName: String,
    siteType: String,
    currentTopInfoData: Object,
    isDataLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isNumber: isNumber,
    openModal: function openModal() {
      this.$emit('open-modal');
    }
  }
};